module.exports = __webpack_public_path__ + "static/media/header.d9216fcb.jpg";